import { Box, Button } from '@nimbus-ds/components';
import { InitialScreen } from '@nimbus-ds/patterns';
import { useHistory } from 'react-router-dom';
import { useResponsive } from 'commons/components';
import { CUSTOMERS_SECTION_ROUTES } from 'domains/Customers/Customers';
import { useTranslationCustomers } from 'domains/Customers/hooks';
import {
  SectionAppCard,
  SectionAppCardDomains,
} from 'domains/PartnersApps/components';
import initialScreenImg from '../../initial-screen.svg';

export default function CustomerInitialScreen(): JSX.Element {
  const t = useTranslationCustomers();
  const { push } = useHistory();

  const { isMobile } = useResponsive();

  return (
    <Box display="flex" justifyContent="center" mb={isMobile ? '2' : '8'}>
      <InitialScreen>
        <InitialScreen.Hero
          title={t('emptyResults.title')}
          subtitle={t('emptyResults.subtitle').toUpperCase()}
          description={t('emptyResults.body')}
          image={
            <img src={initialScreenImg} width="100%" height="auto" alt="" />
          }
          actions={
            <Box>
              <Box display="flex" gap="4" flexWrap="wrap">
                <Button
                  appearance="primary"
                  onClick={() => push(CUSTOMERS_SECTION_ROUTES.customerNew)}
                >
                  {t('emptyResults.action_primary')}
                </Button>
                <Button
                  appearance="neutral"
                  onClick={() =>
                    push(CUSTOMERS_SECTION_ROUTES.customerEmptyImport)
                  }
                >
                  {t('emptyResults.action_secondary')}
                </Button>
              </Box>

              <InitialScreen.Module
                title=""
                description=""
                gap="4"
                paddingTop="8"
              >
                <Box>
                  <SectionAppCard
                    source={CUSTOMERS_SECTION_ROUTES.customerList}
                    appCategory="marketing"
                    domain={SectionAppCardDomains.CUSTOMERS}
                  />
                </Box>
              </InitialScreen.Module>
            </Box>
          }
        />
      </InitialScreen>
    </Box>
  );
}
